module.exports = __webpack_public_path__ + "img/72b9682.jpg";